// src/utils/sanitizeUserTextInput.js
// Shared client-side text hardening for user-editable fields.

const INJECTION_PATTERN = /javascript:|on\w+\s*=/gi;
const PERSISTED_TEXT_UNSAFE_CHARS = /[^\p{L}\p{N}\s\-'.]/gu;
const SEARCH_UNSAFE_CHARS = /[<>\0\x00-\x1F\x7F]/g;

export const MAX_SEARCH_INPUT_LENGTH = 200;
export const MAX_PERSISTED_TEXT_LENGTH = 255;
export const MAX_REQUEST_COMMENT_LENGTH = 2000;

const COMMENT_UNSAFE_CHARS = /[<>\0\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g;

export function containsTextInjection(value) {
  return INJECTION_PATTERN.test(String(value));
}

/** Thread titles — plain text, blocks HTML/script injection */
export function sanitizeChatThreadTitleDraft(value, maxLength = MAX_PERSISTED_TEXT_LENGTH) {
  return String(value)
    .replace(/\0/g, '')
    .replace(INJECTION_PATTERN, '')
    .replace(/[<>]/g, '')
    .slice(0, maxLength);
}

/** Persisted labels/names (ship userLabel, etc.) */
export function sanitizePersistedUserTextDraft(value, maxLength = MAX_PERSISTED_TEXT_LENGTH) {
  return String(value)
    .replace(/\0/g, '')
    .replace(INJECTION_PATTERN, '')
    .replace(PERSISTED_TEXT_UNSAFE_CHARS, '')
    .slice(0, maxLength);
}

/** Local/API search boxes — broader charset, blocks HTML/script injection */
export function sanitizeSearchInput(value, maxLength = MAX_SEARCH_INPUT_LENGTH) {
  return String(value)
    .replace(SEARCH_UNSAFE_CHARS, '')
    .replace(INJECTION_PATTERN, '')
    .slice(0, maxLength);
}

/** Reviewer comments (textarea) — allows newlines, blocks HTML/script injection */
export function sanitizeRequestCommentDraft(value, maxLength = MAX_REQUEST_COMMENT_LENGTH) {
  return String(value)
    .replace(COMMENT_UNSAFE_CHARS, '')
    .replace(INJECTION_PATTERN, '')
    .slice(0, maxLength);
}

/** Gameloop tag save payload — positive integer IDs only */
export function sanitizeTagIds(raw) {
  if (!Array.isArray(raw)) return [];
  const out = [];
  const seen = new Set();
  for (const value of raw) {
    const id = Number(value);
    if (!Number.isInteger(id) || id < 1 || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
}
